"use client";

import { Card, CardFooter } from "@nextui-org/react";
import { WooCommerceProduct } from "@/types/woocommerce";

interface ProductCardProps {
  product: WooCommerceProduct;
}

export function ProductCard({ product }: ProductCardProps) {
  return (
    <Card className="w-full h-full group hover:shadow-2xl transition-all duration-300 border-0 rounded-xl bg-white overflow-hidden">
      <div className="p-4 flex flex-col h-full">
        {/* Product Name */}
        <h3 className="product-name text-gray-900 mb-3 flex-1">
          {product.name}
        </h3>
        
        {/* Rating */}
        {product.average_rating && parseFloat(product.average_rating) > 0 && (
          <div className="flex items-center gap-2 mb-4">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={i < Math.round(parseFloat(product.average_rating)) ? "text-yellow-400 text-sm" : "text-gray-300 text-sm"}>
                  ★
                </span>
              ))}
            </div>
            <span className="text-xs text-gray-600 font-medium">({product.rating_count})</span>
          </div>
        )}
        
        {/* Short Description */}
        {product.short_description && (
          <p 
            className="text-sm text-gray-600 line-clamp-4"
            dangerouslySetInnerHTML={{ __html: product.short_description }}
          />
        )}
      </div>
    </Card>
  );
}
